import { INavigationService } from '../../interfaces';
import { Injectable } from "@angular/core";

@Injectable()
export class DefaultNavigationService implements INavigationService {
    getMenuConfigurations(): any {
        return undefined;
    }
    getParentPageId(): string {
        return undefined;
    }

    setParentPageId(parentPageId: string) {}

    getChildPageName(url: string): string {
        return undefined;
    }

    setQueryParams(url: string) {}

    getQueryParams(): any {
        return undefined;
    }

    getGroupName(): string {
        return undefined;
    }

    getDeviceType(): string {
        return undefined;
    }

    setChildPageId(childId: string) {}

    getChildPageId(): string {
        return undefined;
    }

    handleNavigation(navigation: any) {}

    handleNavigationWithDomain(domain: string) {}

    setCurrentUrl(url: string) {}

    getCurrentUrl(): any {
        return undefined;
    }

    setParentPage(parentPage: any) {}

    getParentPage(): any {
        return undefined;
    }

    setChildPage(childpage: any) {}

    getChildPage(): any {
        return undefined;
    }

    setGrandChildPageId(grandChildId: string) {}

    getGrandChildPageId(): string {
        return undefined;
    }

    setGrandChildPage(grandChildPage: any) {}

    getGrandChildPage(): any {
        return undefined;
    }
    setFourthChildPageId(fourthChildId: string) {}

    getFourthChildPageId(): string {
        return undefined;
    }
    setFourthChildPage(fourthChildPage: any) {}

    getFourthChildPage(): any {
        return undefined;
    }

    setContextAndNavigate(domain: string, value: any, targetUrl: string) {}

    navigateOnContext(contextType: string, contextValue: any): any {}

    navigateOnAction(contextType: string, contextValue: any, target: string): any {}

    setComingSoonMsgInd() {}

    getComingSoonMsgInd(): any {
        return undefined;
    }
}
